import React from "react";
import { Link } from "react-router-dom";

/* Read-only (admin view) renders links as plain text so nothing navigates or writes. */
export const RL = ({ ro, to, children, ...rest }) => (ro ? <span {...rest}>{children}</span> : <Link to={to} {...rest}>{children}</Link>);
